import { render, staticRenderFns } from "./BeforeTurn.vue?vue&type=template&id=58baa7d5&scoped=true&lang=pug&"
import script from "./BeforeTurn.vue?vue&type=script&lang=js&"
export * from "./BeforeTurn.vue?vue&type=script&lang=js&"
import style0 from "./BeforeTurn.vue?vue&type=style&index=0&id=58baa7d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58baa7d5",
  null
  
)

export default component.exports